import { extractPkFromLocation } from '../../scripts/helpers/extractPkFromLocation.js';
import { extractDistributionOutletFromLocation } from '../../scripts/helpers/extractDistributionOutletFromLocation.js';
import { checkPkInSessionStorage, getPkFromSessionStorage, setPkInSessionStorage } from '../../scripts/helpers/handlePkInSessionStorage.js';
import { checkDistributionOutletInSessionStorage, getDistributionOutletFromSessionStorage, setDistributionOutletInSessionStorage } from '../../scripts/helpers/handleDistributionOutletInSessionStorage.js';

class SharePkNumber {
  #linkElement;

  constructor(linkElement) {
    this.#linkElement = linkElement;
  }

  init() {
    let pk = '';
    let distributionOutlet = '';

    if (!checkPkInSessionStorage()) {
      const pkFromLocation = extractPkFromLocation(location);

      if (pkFromLocation !== '') {
        pk = pkFromLocation;
        setPkInSessionStorage(pkFromLocation);
      } else {
        pk = window.tb.PROVIDED_COUNTRY === 'AT' ? '3.at.100.1' : '1.de.4007.1';
        setPkInSessionStorage(pk);
      }
    } else {
      const pkFromLocation = extractPkFromLocation(location);

      if (pkFromLocation !== '' && getPkFromSessionStorage() !== pkFromLocation) {
        pk = pkFromLocation;
        setPkInSessionStorage(pkFromLocation);
      } else {
        pk = getPkFromSessionStorage();
      }
    }

    if (!checkDistributionOutletInSessionStorage()) {
      const distributionOutletFromLocation = extractDistributionOutletFromLocation(location);

      if (distributionOutletFromLocation !== '') {
        distributionOutlet = distributionOutletFromLocation;
        setDistributionOutletInSessionStorage(distributionOutletFromLocation);
      } else {
        distributionOutlet = pk;
      }
    } else {
      const distributionOutletFromLocation = extractDistributionOutletFromLocation(location);

      if (distributionOutletFromLocation !== '' && getDistributionOutletFromSessionStorage() !== distributionOutletFromLocation) {
        distributionOutlet = distributionOutletFromLocation;
        setDistributionOutletInSessionStorage(distributionOutletFromLocation);
      } else {
        distributionOutlet = getDistributionOutletFromSessionStorage();
      }
    }

    if (this.#linkElement.getAttribute('disabled') !== null) {
      this.#linkElement.removeAttribute('disabled');
    }

    this.#linkElement.addEventListener('click', evt => {
      evt.preventDefault();

      if (pk !== '' || distributionOutlet !== '') {
        const targetUrl = new URL(this.#linkElement.href);

        if (pk !== '') {
          targetUrl.searchParams.set('pk', pk);
        }

        targetUrl.searchParams.set('vertriebsstelle', distributionOutlet);
        window.open(targetUrl.href, this.#linkElement.dataset?.target ?? '_self');
      } else {
        window.open(this.#linkElement.href, this.#linkElement.dataset?.target ?? '_self');
      }
    });
  }
}

const sharePkNumberElements = document.querySelectorAll('[data-js-block="sharePkNumber"]');

if (sharePkNumberElements.length > 0) {
  sharePkNumberElements.forEach(sharePkNumberElement => {
    const sharePkNumberClass = new SharePkNumber(sharePkNumberElement);
    sharePkNumberClass.init();
  });
}

export default SharePkNumber;
